/**
 * @copyright       Palace Resorts
 * @description     Mensajes para el layout de usuarios de la aplicación (Members Layout)
 * @author          Roberto Pérez Guzmán
 * @creationDate    03 de Mayo del 2020
 */
export default {
    fallbackLocale: 'ESP',
    locale: 'ESP',
    messages: {
        'ESP': {
            lblAdmin: 'DASHBOARD',
            lblHome: 'Inicio',
            lblNewRegisterOutsourcing: 'Nuevo registro outsourcing',
            lblSignOut: 'Cerrar sesión',
            lblDashboard: 'Dashboard',
            lblSwitchlocale: 'Set language to ENGLISH',
            lblLoading: "Por favor espere, su solicitud está siendo atendida.",
        },
        'ENG': {
            lblHome: 'Employee list',
            lblNewRegisterOutsourcing: 'New register outsourcing',
            lblSignOut: 'signOut',
            lblSwitchlocale: 'Cambiar idioma a ESPAÑOL',
            lblDashboard: 'Dashboard',
            lblLoading: "Please stand by, your request is being processed.",
        }
    } //end Messages
}